if (!customElements.get('ce-product-details')) {
  customElements.define('ce-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      const source = this.querySelector('[data-ce-description]');
      if (!source) return;
      this.dataset.ready = 'true';
      const flatten = (parent) => {
        Array.from(parent.children).forEach((child) => {
          if (child.tagName !== 'DIV' || child.attributes.length) return;
          flatten(child);
          const hasBlocks = Array.from(child.children).some((node) => /^(DIV|P|H[2-6]|UL|OL|TABLE)$/.test(node.tagName));
          const hasText = Array.from(child.childNodes).some((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
          if (hasBlocks && !hasText) child.replaceWith(...child.childNodes);
        });
      };
      flatten(source);
      const legacyHeadings = new Set(['reliable performance', 'accessibility for all', 'internal display', 'external display']);
      const isHeading = (node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        if (/^H[2-6]$/.test(node.tagName)) return true;
        if (!/^(DIV|P)$/.test(node.tagName)) return false;
        const label = node.textContent.trim();
        if (!label || label.length > 85) return false;
        if (legacyHeadings.has(label.toLowerCase())) return true;
        return Array.from(node.childNodes).every((child) => {
          if (child.nodeType === Node.TEXT_NODE) return !child.textContent.trim();
          return child.nodeType === Node.ELEMENT_NODE && /^(B|STRONG|BR)$/.test(child.tagName);
        }) && !!node.querySelector('b,strong');
      };
      const groups = [];
      let group = { heading: null, nodes: [] };
      Array.from(source.childNodes).forEach((node) => {
        if (isHeading(node)) {
          if (group.heading || group.nodes.some((item) => item.textContent.trim())) groups.push(group);
          group = { heading: node, nodes: [] };
        } else {
          group.nodes.push(node);
        }
      });
      if (group.heading || group.nodes.some((item) => item.textContent.trim())) groups.push(group);
      if (!groups.length) return;
      const fragment = document.createDocumentFragment();
      groups.forEach((item, index) => {
        const details = document.createElement('details');
        details.className = 'ce-product-details__item';
        const summary = document.createElement('summary');
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', 'false');
        const heading = document.createElement('h3');
        heading.className = 'ce-product-details__heading';
        if (item.heading) heading.append(...item.heading.childNodes);
        else heading.textContent = this.dataset.overview;
        const indicator = document.createElement('span');
        indicator.className = 'ce-product-details__indicator';
        indicator.setAttribute('aria-hidden', 'true');
        summary.append(heading, indicator);
        const content = document.createElement('div');
        content.className = 'ce-product-details__panel';
        content.id = `ce-details-${this.dataset.section}-${index}`;
        summary.setAttribute('aria-controls', content.id);
        details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
        content.append(...item.nodes);
        details.append(summary, content);
        fragment.append(details);
      });
      source.replaceChildren(fragment);
    }
  });
}
